import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  LOGGEDINUSER, UserAgentService, User, ApiService, AppInitializerService, AppService, GtmService, NavigationHelper,
} from '@lc/core';
import { Router } from '@angular/router';
import { catchError, Observable, of, map, switchMap, tap, withLatestFrom, filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lc-photo-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private api = inject(ApiService);
  router = inject(Router);
  private gtagService = inject(GtmService);
  private appInitializer = inject(AppInitializerService);

  private readonly GTAG_MAP = new Map([['prod', 'GTM-MXFDPKC']]);

  constructor() {
    const store = inject<Store<any>>(Store);
    const userAgentService = inject(UserAgentService);
    const { router } = this;
    const { appInitializer } = this;

    userAgentService.doBrowserCheck();
    appInitializer.initializeKeys('lc-photo-app', AppService.productSuiteName);

    const user$: Observable<User> = store.select(LOGGEDINUSER).pipe(
      filter((user: User) => !!user?.profile),
    );

    NavigationHelper.urlChanged$(router)
      .pipe(
        withLatestFrom(user$),
        tap(([url, user]) => {
          const event = {
            event: 'virtualPageview',
            page_path: url,
            country: 'US',
            userType: 'Photographer',
            oktaID: user.oktaId,
            emailAddress: user.profile.preferredEmail || 'email',
            createdAt: Math.round(new Date(user.profile.audit?.createdAt || Date.now()).getTime() / 1000),
          };

          this.gtagService.pushEvent(this.GTAG_MAP, event);
        }),
        filter(([url]) => appInitializer.shouldRefresh(appInitializer.getBaseUrl(url))),
        switchMap(([url]) => this.api.get<{ items: { vendorId: string }[]; legacyAgencyIds: string[] }>('photography/vendors').pipe(
          map((response) => [...response.items.map((vendor) => vendor.vendorId), ...response.legacyAgencyIds]),
          catchError(() => of<string[]>([])),
          tap((ownerIds) => appInitializer.refreshNotifications(url, ownerIds)),
        )),
        takeUntilDestroyed(),
      ).subscribe();
  }
}
